import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo } from '../data/mock';
import { MapPin } from 'lucide-react';

const LocationSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="location" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl text-stone-800 mb-4">
            {t.location.title}
          </h2>
          <div className="flex items-center justify-center text-stone-500 text-lg">
            <MapPin size={20} className="mr-2" />
            <p>{t.location.subtitle}</p>
          </div>
        </div>

        {/* Map */}
        <div className="aspect-[16/9] md:aspect-[21/9] w-full bg-stone-200 overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.5074774851787!2d-5.145833823538635!3d36.42546147236847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd0c78f9f3c3f3f3%3A0x0!2sCalle%20Papuecas%2024%2C%20Estepona!5e0!3m2!1ses!2ses!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map"
            className="grayscale-[50%] hover:grayscale-0 transition-all duration-500"
          />
        </div>

        {/* Address */}
        <div className="text-center mt-8">
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactInfo.address)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-600 hover:text-amber-700 transition-colors inline-flex items-center"
          >
            <MapPin size={16} className="mr-2" />
            {contactInfo.address}
          </a>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
